if (!customElements.get('klaviyo-signup-handler')) {
  class KlaviyoSignupHandler extends HTMLElement {
    constructor() {
      super();
      this.pageLoadTime = Date.now();
      this.recaptchaSiteKey = '6LfsExIrAAAAAHhjQFda-2q716lgLTt4JP6LgV-q';
      this.recaptchaToken = null;
      this.passedRecaptcha = false;
      this.lowScore = false;
      this.recaptchaScoreIsSet = false;
    }

    connectedCallback() {
      this.formContainer = document.getElementById('email_signup_footer');
      if (this.formContainer) {
        this.submitButton = this.formContainer.querySelector('[data-klaviyo-submit-real]');
        if (this.submitButton) {
          this.submitButton.addEventListener('click', this.handleSubmit);
        } else {
          console.error('Klaviyo submit button not found within the form.');
        }
      } else {
        console.error('Klaviyo form container with ID "email_signup_footer" not found.');
      }

      this.attemptRecaptchaRender();
    }

    handleRecaptchaCallback = async (token) => {
      this.recaptchaToken = token;
      try {
        const response = await fetch('https://verify-captcha-730964904798.us-central1.run.app', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            recaptchaToken: this.recaptchaToken,
          }),
        });

        const data = await response.json();

        if (data.success) {
          this.lowScore = false;
        } else {
          this.lowScore = true;
          console.error('recaptcha validation failed:', data.message);
        }
        this.recaptchaScoreIsSet = true;
      } catch (error) {
        console.error('Request failed:', error);
      }
    };

    attemptRecaptchaRender = () => {
      if (typeof grecaptcha !== 'undefined' && typeof grecaptcha.enterprise.render === 'function' && this.formContainer && this.formContainer.querySelector('#recaptcha-container')) {
        grecaptcha.enterprise.render(this.formContainer.querySelector('#recaptcha-container'), {
          sitekey: this.recaptchaSiteKey,
          callback: this.handleRecaptchaCallback,
          'expired-callback': function () {
            console.log("token timeout")
            this.recaptchaScoreIsSet = false;
          }
        });
      }
      else {
        console.warn('grecaptcha not fully loaded, retrying in 100ms...');
        setTimeout(this.attemptRecaptchaRender, 100);
      }
    };

    disconnectedCallback() {
      if (this.submitButton) {
        this.submitButton.removeEventListener('click', this.handleSubmit);
      }
    }



    handleSubmit = (event) => {
      event.preventDefault();

      const formContainer = document.getElementById('email_signup_footer');
      if (!formContainer) {
        console.error('Form container with ID "email_signup_footer" not found during submission.');
        return;
      }

      // **Bot detection: Check submission time**
      const submissionTime = Date.now();
      const timeElapsed = (submissionTime - this.pageLoadTime) / 1000;

      if (timeElapsed < 5) {
        console.log(`Bot detected - form submitted too quickly (${timeElapsed} seconds).`);
        return;
      }

      // **Honeypot check**
      const honeypotInput = formContainer.querySelector('input[name="website"]');
      if (honeypotInput && honeypotInput.value.trim() !== '') {
        console.log('Bot detected - honeypot filled.');
        return;
      }

      const emailInput = formContainer.querySelector('input[name="email"]');
      const phoneInput = formContainer.querySelector('input[name="$phone_number"]');
      const smsConsentCheckbox = formContainer.querySelector('input[name="sms-consent"]');
      const emailConsentCheckbox = formContainer.querySelector('input[name="$consent"]');
      const emailValidation = formContainer.querySelector('.alternate-email-signup__validation');
      const phoneValidation = formContainer.querySelector('.alternate-email-signup__validation.validation_phone');
      const captchaValidation = formContainer.querySelector('.alternate-email-signup__validation.validation_captcha');
      const phoneTermsAgreementsValidation = formContainer.querySelector('.alternate-email-signup__validation.validation_agree_sms');
      const ajaxSubmitUrl = formContainer.getAttribute('data-ajax-submit');

      const email = emailInput ? emailInput.value.trim() : '';
      const phone = phoneInput ? phoneInput.value.trim() : '';
      const smsConsent = smsConsentCheckbox ? smsConsentCheckbox.checked : false;
      const emailConsentChecked = emailConsentCheckbox ? emailConsentCheckbox.checked : false;
      const emailConsentValue = emailConsentCheckbox ? emailConsentCheckbox.value : '';
      const captchaToken = grecaptcha.enterprise.getResponse()

      const showTemporaryValidation = (el) => {
        el?.classList.remove('hidden');
        setTimeout(() => el?.classList.add('hidden'), 3000);
      };

      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        showTemporaryValidation(emailValidation);
        return;
      }

      if (phone && !/^\+?\d+$/.test(phone) || phone && !phone.includes("+")) {
        showTemporaryValidation(phoneValidation);
        return;
      }

      if (phone && /^\+?\d+$/.test(phone) && phone.includes("+") && !smsConsent) {
        showTemporaryValidation(phoneTermsAgreementsValidation);
        return;
      }

      if (!captchaToken) {
        showTemporaryValidation(captchaValidation);
        return;
      }

      if (!this.recaptchaScoreIsSet) {
        return;
      }

      if (this.lowScore) {
        console.log("bot activity");
        return;
      }

      const formData = new URLSearchParams();
      formData.append('g', formContainer.querySelector('input[name="g"]').value);
      formData.append('email', email);
      let fields = 'email, $consent';

      if (phone) {
        formData.append('$phone_number', phone);
        fields += ', $phone_number';
        if (smsConsent) {
          formData.append('sms_consent', 'true');
          fields += ', sms_consent';
        }
      }

      if (emailConsentChecked) {
        formData.append('$consent', emailConsentValue);
        fields += ', $consent';
      } else {
        formData.append('$consent', '');
      }

      if (ajaxSubmitUrl) {
        fetch(ajaxSubmitUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          mode: 'cors',
          body: formData.toString()
        })
          .then(response => {
            if (response.ok) {
              return response.text();
            } else {
              console.error('Klaviyo submission failed:', response.status, response.statusText);
              return response.text().then(text => console.error('Klaviyo error response:', text));
            }
          })
          .then(data => {
            if (window.fbq) {
              window.fbq('track', 'Lead');
            }
            const successMessage = formContainer.querySelector('.success_message');
            if (successMessage) {
              successMessage.style.display = 'block';
              formContainer.querySelectorAll('.newsletter-form__field-wrapper, .consent-container, .alternate-email-signup__submit-button, #recaptcha-container').forEach(el => el.style.display = 'none');
            }
          })
          .catch(error => {
            console.error('Error submitting to Klaviyo:', error);
          });
      } else {
        console.error('Klaviyo form data-ajax-submit URL not found.');
      }
    };
  }
  customElements.define('klaviyo-signup-handler', KlaviyoSignupHandler);
}